if (!customElements.get('terence-ambassador-film')) {
  customElements.define('terence-ambassador-film', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const opts = {signal:this.events.signal};
      const dialog = this.querySelector('dialog');
      const video = this.querySelector('video');
      const trigger = this.querySelector('.tb-gina-film-link');
      trigger.addEventListener('click', () => {
        dialog.showModal();
        video.play().catch(() => {});
      }, opts);
      this.querySelector('.tb-gina-close').addEventListener('click', () => dialog.close(), opts);
      dialog.addEventListener('close', () => {video.pause();trigger.focus();}, opts);
      dialog.addEventListener('click', event => {
        if(event.target !== dialog) return;
        const r=dialog.getBoundingClientRect();
        if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close();
      }, opts);
      video.addEventListener('error', () => {this.querySelector('.tb-gina-error').hidden=false;}, opts);
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.events?.abort();
      this.events=null;
    }
  });
}
